import React from 'react'

function CreateReport() {
  return (
    <div>
      
    </div>
  )
}

export default CreateReport
